import { svgIcon } from './kit';

// The one audio control the game exposes (H12). Deliberately a single MASTER mute rather than
// music/SFX sliders: relative level already lives in the per-cue trim, so a player who wants
// "quieter" wants "off", and a settings panel nobody opens is not a feature.
//
// It appears twice — the main menu's utility bar and the break menu — and both instances share
// one store, so toggling either moves the other. `onExternalChange` is what keeps them in sync.

export interface MuteToggleOpts {
  isMuted(): boolean;
  setMuted(muted: boolean): void;
  /** Label style: the menu bar shows text, the break menu is a full-width CTA. */
  variant: 'bar' | 'cta';
}

export interface MuteToggle {
  readonly el: HTMLButtonElement;
  /** Re-read the store and repaint — call when the other instance toggled. */
  sync(): void;
}

export function createMuteToggle(doc: Document, opts: MuteToggleOpts): MuteToggle {
  const btn = doc.createElement('button');
  btn.type = 'button';
  btn.className = opts.variant === 'cta' ? 'modal-cta break-mute' : 'mute-toggle';
  btn.dataset['muteToggle'] = '1';
  const icon = doc.createElement('span');
  icon.className = 'mute-icon';
  const label = doc.createElement('span');
  label.className = 'mute-label';
  btn.append(icon, label);

  const paint = (): void => {
    const muted = opts.isMuted();
    // aria-pressed describes the TOGGLE, so it is true when sound is off.
    btn.setAttribute('aria-pressed', muted ? 'true' : 'false');
    btn.setAttribute('aria-label', muted ? 'Unmute sound' : 'Mute sound');
    btn.dataset['muted'] = muted ? '1' : '0';
    icon.replaceChildren(svgIcon(doc, muted ? 'sound-off' : 'sound-on', opts.variant === 'cta' ? 16 : 14));
    label.textContent = muted ? 'Sound off' : 'Sound on';
  };

  btn.addEventListener('click', () => {
    opts.setMuted(!opts.isMuted());
    paint();
  });
  paint();
  return { el: btn, sync: paint };
}
